import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";
import { BASE_URL } from "../../../Api/config";

export const getOrgUnitListData = async (params?: Record<string, any>) => {
  console.log("paaararaarrrra", params);
  const response = await axiosInstance.get(
    API_ENDPOINTS.ONBOARDING.GET_ORG_UNIT_LIST,
    { params }
  );

  console.log("🚀 ~ OnBoardingRepo.ts:9 ~ getLeadType ~ response:", response);

  return response?.data;
};

export const getOnboardingRequestData = async (
  params?: Record<string, any>
) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.ONBOARDING.GET_ONBOARD_REQUEST_LIST,
    { params: params }
  );

  console.log("🚀 ~ OnBoardingRepo.ts:21 ~ response:", response);

  return response?.data;
};

export const getOnboardingStatusData = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.ONBOARDING.GET_ONBOARDING_STATUS
  );

  console.log("🚀 ~ OnBoardingRepo.ts:34 ~ response:", response);

  return response?.data;
};

export const getOnboardingOutletTypesData = async (
  params?: Record<string, any>
) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.ONBOARDING.GET_OUTLET_TYPES
  );

  console.log(
    "🚀 ~ OnBoardingRepo.ts:40 ~ getOnboardingStatusData ~ response:",
    response
  );

  return response?.data;
};

export const getOnboardEDMDetailsData = async (id: string | number) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.ONBOARDING.GET_ONBOARD_EDM_DETAILS}/${id}`
  );

  console.log("🚀 ~ OnBoardingRepo.ts:57 ~ response:", response);

  return response?.data;
};

export const getOnboardAddressListData = async (
  id: string | number,
  params: any
) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.ONBOARDING.GET_ONBOARD_ADDRESS_LIST}/${id}`,
    { params: params }
  );

  console.log(
    "🚀 ~ OnBoardingRepo.ts:67 ~ getOnboardAddressListData ~ response:",
    response
  );

  return response?.data;
};

export const getOrganizationRecordsListsData = async (
  id: string | number,
  params: any
) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.ONBOARDING.GET_ORGANIZATION_RECORDS_LISTS}/${id}`,
    { params: params }
  );

  console.log("🚀 ~ OnBoardingRepo.ts:88 ~ response:", response);

  return response?.data;
};

export const getOnboardingRequestLogsData = async (
  id: string | number,
  params: any
) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.ONBOARDING.GET_ONBOARDING_REQUEST_LOGS}/${id}`,
    { params: params }
  );

  console.log("🚀 ~ OnBoardingRepo.ts:102 ~ response:", response);

  return response?.data;
};

export const getOnBoardRequiredFieldsList = async (
  params?: Record<string, any>
) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.ONBOARDING.GET_ONBOARD_REQURIED_FIELD_LIST,
    { params: params }
  );
  console.log(
    "🚀 ~ file: OnboardingRepo.ts ~ line 100 ~ getOnBoardRequiredFieldsList ~ response",
    response?.data?.data?.data
  );
  return response;
};

export const addOnboardRequried = async (body: any) => {
  return axiosInstance.post(
    API_ENDPOINTS.ONBOARDING.ADD_ONBOARD_REQURIED,
    body
  );
};
export const getSingleAddressData = async (id: string | number) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.ONBOARDING.GET_ONBOARD_SINGLE_ADDRESS}/${id}`
  );

  return response?.data;
};

export const getVisitFrequencyData = async () => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.ONBOARDING.GET_OUTLET_VISIT_FREQUENCY}`
  );

  return response?.data;
};

export const getStateListData = async () => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.ONBOARDING.GET_STATE_LIST}`
  );

  console.log(
    "🚀 ~ OnBoardingRepo.ts:128 ~ getStateListData ~ response:",
    response
  );

  return response?.data;
};
export const getTerritoriesData = async (params: any) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.ONBOARDING.GET_TERRITORIES}`,
    { params: params }
  );

  console.log(
    "🚀 ~ OnBoardingRepo.ts:161 ~ getTerritoriesData ~ response:",
    response
  );

  return response?.data;
};

export const getAllPositionData = async (params: any) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.ONBOARDING.GET_ALL_POSITION}`,
    { params: params }
  );

  console.log(
    "🚀 ~ OnBoardingRepo.ts:174 ~ getAllPositionData ~ response:",
    response
  );

  return response?.data;
};

export const updateOnboardingRequest = async (
  id: string | number,
  body: any
) => {
  const response = await axiosInstance.put(
    `${API_ENDPOINTS.ONBOARDING.UPDATE_ONBOARDING_REQUEST}/${id}`,
    body
  );

  console.log("🚀 ~ OnBoardingRepo.ts:192 ~ response:", response);

  return response?.data;
};

export const updateOnboardingAddress = async (
  id: string | number,
  body: any
) => {
  const response = await axiosInstance.put(
    `${API_ENDPOINTS.ONBOARDING.UPDATE_ADDRESS}/${id}`,
    body
  );

  console.log("🚀 ~ OnBoardingRepo.ts:205 ~ response:", response);

  return response?.data;
};

export const getAllTowns = async (params: any) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.ONBOARDING.GET_ALL_TOWNS}`,
    { params: params }
  );

  console.log("🚀 ~ OnBoardingRepo.ts:203 ~ getAllTowns ~ response:", response);

  return response?.data;
};

export const getCityAndState = async (params?: any) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.ONBOARDING.GET_CITY_STATE}`,
    { params: params }
  );

  console.log(
    "🚀 ~ OnBoardingRepo.ts:214 ~ getCityAndState ~ response:",
    response
  );

  return response?.data;
};

export const getClassification = async (params?: any) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.ONBOARDING.GET_CLASSIFICATION}`,
    { params: params }
  );

  console.log(
    "🚀 ~ OnBoardingRepo.ts:228 ~ getClassification ~ response:",
    response
  );

  return response?.data;
};

export const updateBulkOnboardRequest = async (body?: any) => {
  const response = await axiosInstance.put(
    `${API_ENDPOINTS.ONBOARDING.BULK_ONBOARDING_REQUEST}`,
    body
  );

  console.log(
    "🚀 ~ OnBoardingRepo.ts:256 ~ updateBulkOnboardRequest ~ response:",
    response
  );

  return response?.data;
};

export const updateOnboardWindow = async (body: any) => {
  return axiosInstance.post(
    `${API_ENDPOINTS.ONBOARDING.API_ONBOARD_WINDOW}`,
    body
  );
};

// GET_MEDIA_FILES_BY_IDS
export const sendMediaIds = async (mediaIds: (string | number)[]) => {
  try {
    const response = await axiosInstance.post(
      API_ENDPOINTS.MEDIA.GET_MEDIA_FILES_BY_IDS, // 🔹 Replace with your actual API endpoint
      {
        media_ids: mediaIds.map((id) => Number(id)), // Ensure they are numbers
      }
    );

    console.log("✅ Media IDs sent successfully:", response.data);
    return response.data; // Return API response if needed
  } catch (error: any) {
    console.error(
      "❌ Error sending media IDs:",
      error?.response?.data || error
    );
    throw error;
  }
};
